import styled from '@emotion/styled';

const CreateMultipleQuoteStyle = styled('div')`
    .sub-title {
        font-weight: 700;
        margin-bottom: 16px;
    }
    .wrap-quote {
        overflow-y: auto;
        max-height: calc(100vh - 320px);
        .ant-flex {
            padding: 8px 0;
        }
    }

    .btn-group {
        margin-top: 16px;
    }
`;

export default CreateMultipleQuoteStyle;
